
export const validateEnv = (envVarsNames: string[]): void => {
  envVarsNames.forEach(envVarName => {
    if (!process.env[envVarName]) {
      throw Error(`Env var "${envVarName}" is not defined. This script require this environment variable to exist, please make sure it's defined correctly in your gitlab ci configuration or by your scripts.`)
    }
  })
}